import { MsalProvider } from '@azure/msal-react'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import 'bootstrap-icons/font/bootstrap-icons.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter, useNavigate } from 'react-router-dom'

import App from './App'
import { CustomNavigationClient, msalInstance } from './authConfig'
import './i18n'
import './index.css'
import { defaultQueryClientConfig } from './queryClientConfig'
import store from './store/store'
import theme from './theme'

import "driver.js/dist/driver.css";

import 'react-international-phone/style.css';

const queryClient = new QueryClient({ defaultOptions: defaultQueryClientConfig })

interface MsalConfigurationProviderProps {
  children: React.ReactNode
}

const MsalConfigurationProvider = ({ children }: MsalConfigurationProviderProps) => {
  const navigate = useNavigate()
  msalInstance.setNavigationClient(new CustomNavigationClient(navigate))
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <MsalConfigurationProvider>
          <Provider store={store}>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <App />
            </ThemeProvider>
          </Provider>
        </MsalConfigurationProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
